<template>
  <div class="page">
    <el-form :inline="true" ref="form" label-width="120px">
		<div style="display: flex; justify-content: space-between;">
			<div style="display: flex; align-items: center;">
				<el-form-item label="服务商">
					<el-cascader v-model="spIdDepartName" :options="providerOptions" :props="{ checkStrictly: true, expandTrigger: 'hover' }"></el-cascader>
				</el-form-item>
				<el-form-item label="余额：" v-if="creditLimit !== '' && spBalance !== ''" style="margin-right: 50px; ">
				  <span style="color:red; background-color: #FFFFCC; padding: 10px 20px;">{{spBalance}}{{parseFloat(spBalance)>parseFloat(creditLimit)?'':'(已超额)'}}<i class="el-icon-info" style="font-size: 18px;color:#0066FF;"></i></span>
				</el-form-item>
<!-- 				<el-form-item :label="'信用额度'+(creditLimitDays?'(动态)':'(固定)')+'：'" v-if="creditLimit !== '' && creditLimitDays !== ''">
					<span style="color:red;">{{creditLimit}}</span>
				</el-form-item>
				<el-form-item label="余额：" v-if="creditLimit !== '' && spBalance !== ''">
				  <span style="color:red;">{{spBalance}}{{parseFloat(spBalance)>parseFloat(creditLimit)?'':'(已超额)'}}</span>
				</el-form-item>
				<el-form-item label="跟进人：" v-if="Servicestafflist.length">
				  <el-button type="text" v-for="(item,i) in Servicestafflist" :key="i" @click="cellclickwechatbranch(spId)" style="color:blue;">{{item.userName}}</el-button>
				</el-form-item>
				<div v-if="creditLimitDays !== '' && creditLimitDays" style="color: gray;font-size: 10px;">信用额度(动态)=最近{{creditLimitDays}}天运单总额*{{creditLimitFreightMultiplier}}，最低{{creditLimitMin}}，最高{{creditLimitMax}}</div>
 -->			
				<el-popover placement="right" :width="'176'" trigger="click" v-if="$qiniu != null && salesMan != null">
					<div v-if="salesMan.wechatQRCode != ''">
						<img :src="$qiniu.domain + salesMan.wechatQRCode" style="width: 150px;height: 150px;display: block;">
						<span style="display: block;color: teal;width: 150px;text-align: center;">微信联系：{{salesMan.userName}}</span>
						<span style="display: block;color: teal;width: 150px;text-align: center;">{{salesMan.contacts}}</span>     						
					</div>
					<div style="display: flex; height: 40px; cursor: pointer;" slot="reference" v-if="salesMan != null">
						<font-awesome-icon :icon="['fab', 'weixin']" style="margin-right: 12px;color: rgb(42,161,69); font-size: 22px;" />
						<span style="color: rgb(42,161,69);font-size: 18px; font-weight: bold;">{{'业务:' + salesMan.userName}}</span>
					</div>									
				</el-popover>
			</div>
			<div>
				<el-input type="textarea" :rows="4" placeholder="请输入运单号或转单号，多个用逗号隔开" v-model="wayBillNos" @keyup.enter.native="submitForm" style="width: 300px;margin-right: 18px;margin-bottom: 18px;"></el-input>
				<div style="align-self: flex-end;margin-bottom: 18px;margin-left: 16px;">
				  <el-button type="primary" icon="el-icon-search" @click="queryWayBill">查询</el-button>
				  <el-button icon="el-icon-refresh" @click="resetForm">重置</el-button>
				</div>
			</div>
		</div>
		<div style="display: flex">
			<div style="align-self: flex-end;margin-bottom: 18px;margin-left: 16px;">			
				<el-button icon="el-icon-download" @click="handleDownload">导出</el-button>
			</div>
			<div style="width: 20px"></div>
			<el-radio-group v-model="billCountLabel" size="small" v-if="billCountList.length > 0" @change="billCountItemChanged">
			  <el-radio-button v-for="(item, k) in billCountList" :key="k" :label="getBillCountLabel(item)"></el-radio-button>
			</el-radio-group>	
		</div>
    </el-form>
    <el-table-auto :ref="ref" id='questions' name='问题件' :isCheck='false' :column='tableConf' :table-hand='getTable' :down-hand='paraphrase' @cell-dblclick='cellclickwayBillNo' style="flex: 1;display: flex;flex-direction: column;overflow: hidden;">
      <template #tenantId="{row}">
         {{getSpName(row)}}
      </template>
      <template #wayBillNo="{row}">
        <span @click="cellclickwayBillNo(row)" class="blue">{{row.wayBillNo}}</span>
      </template>
      <template #wayBillStatus="{row}">
        <template>
			<span v-if="row.wayBillStatus == 0">待走货<i class="el-icon-shopping-cart-full" style="font-size: 20px; color: red; margin: 0px 5px;"></i></span>
			<span v-if="row.wayBillStatus == 1">待提取<i class="el-icon-truck" style="font-size: 20px; color: fuchsia; margin: 0px 5px;"></i></span>
			<span v-if="row.wayBillStatus == 2">待签收<i class="el-icon-s-promotion" style="font-size: 20px; color: green; margin: 0px 5px;"></i></span>
			<span v-if="row.wayBillStatus == 3">已签收<i class="el-icon-success" style="font-size: 20px; color: blue; margin: 0px 5px;"></i></span>		
			<span v-if="row.wayBillStatus == 4">已退走<i class="el-icon-refresh-left" style="font-size: 20px; margin: 0px 5px;"></i></span>	
			<span v-if="row.wayBillStatus == 5">已作废<i class="el-icon-delete-solid" style="font-size: 20px; color: slategray; margin: 0px 5px;"></i></span>											
        </template>
      </template>
      <template #serviceStatus="{row}">
        <span class="red">{{numtotitflog(row.serviceStatus,0)?'港前问题':numtotitflog(row.serviceStatus,1)?'港后问题':numtotitflog(row.serviceStatus,4)?'收货问题':numtotitflog(row.serviceStatus,5)?'欠费问题':numtotitflog(row.serviceStatus,3)?'待退走':''}}</span>
      </template>
      <template #lastProblemExists="{row}">
        <span class="red">{{row.providerProblemExists}}</span>
      </template>
      <template #serviceInfo="{row}">
        <span class="lins" v-if="row.lastServiceInfo">
          <!-- 有问题状态且问题状态不能有且仅有内部问题（高位第6为）为开 -->
          <span :class="(row.serviceStatus && row.serviceStatus != 64)?'':''">{{row.lastServiceInfo}}</span>
          <div style="display: inline-block;width: 20px;"></div>
          <span class="gray" v-if="row.lastServiceInfoTime">{{row.lastServiceInfoTime.substring(5, 16)}}</span>
          <div style="display: inline-block;width: 20px;"></div>
          <span class="gray" v-if="row.lastServiceInfoToPerson">@{{row.lastServiceInfoToPerson}}</span>
        </span>
      </template>
      <template #trackInfo="{row}">
        <template v-if="row.publicTrackTime && row.lastTrackTime">
          <template v-if="row.publicTrackTime > row.lastTrackTime">
            <div>{{'【'+row.publicTrackTime}}<div style="display: inline-block;width: 20px;"></div>{{row.publicTrackPlace+'】'}}</div>
            <div>{{row.publicTrackInfo}}</div>
          </template>
          <template v-else>
            {{row.lastTrackInfo}}
          </template>
        </template>
        <template v-else-if="row.publicTrackTime">
          <div>{{'【'+row.publicTrackTime}}<div style="display: inline-block;width: 20px;"></div>{{row.publicTrackPlace+'】'}}</div>
          <div>{{row.publicTrackInfo}}</div>
        </template>
        <template v-else>
          {{row.lastTrackInfo}}
        </template>
      </template>
      <template #freight="{row}">
        <span>{{-row.inFreight}}</span>
      </template>	  
      <template #freightAdd="{row}">
        <span>{{-row.inFreightConditionAdd-row.inFreightAdd}}</span>
      </template>	  
      <template #amount="{row}">
        <span>{{-row.inFreight-row.inFreightConditionAdd-row.inFreightAdd}}</span>
      </template>	  	  
      <template #battery="{row}">
        {{row.battery === 0?'无电': row.battery ===  1?'内电':row.battery=== 2? '外电':'纯电'}}
      </template>
      <template #gateDeclared="{row}">
        {{row.gateDeclared ==1?'报关':'不报关'}}
      </template>
    </el-table-auto>
  </div>
</template>

<script>
import Vue from 'vue'
import { page } from '@/mixins/page'
import * as date from '@/utils/date'
export default {
  mixins: [page],
  data() {
    return {
      ref: 'questions',
	  providerOptions: [],
	  spIdDepartName: [],
	  billCountList: [],
	  billCountLabel: '',	  
	  wayBillNos: '',
	  wayBillStatus: -1,
      // form
      serviceStatus: 0,
      // table
      tableConf: [
        { prop: 'createdTime', label: '收货时间', width: 160 },
        //{ template: 'tenantId', label: '服务商', width: 90 },
        { template: 'wayBillNo', label: '原单号', width: 120 },
        { prop: 'transBillNo', label: '转单号', width: 150 },
        { template: 'lastProblemExists', label: '待处理问题', width: 300 },
        { template: 'wayBillStatus', label: '运单状态', width: 100 },
        //{ template: 'serviceStatus', label: '问题状态', width: 100 },
        //{ template: 'serviceInfo', label: '跟进信息', width: 250 },
        { template: 'trackInfo', label: '轨迹信息', width: 200 },
        { prop: 'quoteName', label: '渠道', width: 160 },
        { prop: 'destinationName', label: '目的地', width: 110 },
        { prop: 'pieces', label: '件数', width: 60 },
        { prop: 'settlementWeight', label: '结算重', width: 70 },
        //{ prop: 'goodsTypeName', label: '货物类型', width: 105 },
        //{ template: 'battery', label: '电池', width: 100 },
        //{ template: 'gateDeclared', label: '报关类型', width: 110 },
        //{ prop: 'valueDeclared', label: '申报价值', width: 100 },
        //{ template: 'freight', label: '运费', width: 100 },
        //{ template: 'freightAdd', label: '加收', width: 100 },
        //{ template: 'amount', label: '合计', width: 100 },
        //{ prop: 'spCostRemark', label: '账单备注', width: 200 },
        // { prop: 'outWeight', label: '预报重量', width: 100 },
        // { prop: 'outAmount', label: '预报费用', width: 100 },
        // { prop: 'outQuoteName', label: '预报渠道', width: 160 }
      ]
    }
  },
  async mounted(){
	Vue.prototype.$qiniu = await this.$api.uploadtoken() // 刷新七牛token有效期		  
	let branchList = JSON.parse(localStorage.getItem('branchlist'))
	for(let i = 0, len = branchList.length; i < len; i++){		
		let option = {
			value: branchList[i].branchCode,
			label: branchList[i].branchName,
		}
		if(branchList[i].branchCode == '85689'){
			//LHD特殊处理
			let setting = await this.$api.getDepartmentSetting('85689')
			if(setting && setting.value){
				let departArr = setting.value.split(",")
				option.children = []
				departArr.forEach((departName)=>{
					let childOption = {
						value: departName,
						label: departName
					}
					option.children.push(childOption);
				})
			}
		}
		this.providerOptions.push(option)
	}
	if(this.providerOptions.length > 0){
		this.spIdDepartName = [this.providerOptions[0].value]
	}
	await this.queryBillCount()	
  },  
  methods: {
    // 表格查询
    async getTable(pages) {
		let params = this.buildQueryParams(pages)
		let res = await this.$api.getWayBillPage(params)
		this.$store.commit('layout/setBadge', { Questions: res.total })	
		return res
    },
	buildQueryParams(pages){
		let params = { ...pages, hidenInSettlement: '0', problemExists: 1 }
		// if(this.spIdDepartName.length > 0){
		//   params.spId = this.spIdDepartName[0]
		//   if(this.spIdDepartName.length == 2){
		// 	  params.spDepartName = this.spIdDepartName[1]
		//   }
		// }
		if(this.wayBillStatus >= 0){
			params.wayBillStatus=this.wayBillStatus
		}
		this.wayBillNos = this.wayBillNos.trim().replaceAll('\n', ',')
		if (this.wayBillNos) {
			params = { ...pages, problemExists: 1 }
			params.wayBillNos = this.wayBillNos
		} else {
			params.timeType = 1
			params.startDate = date.formatDate(new Date(new Date() - 1000 * 60 * 60 * 24 * 90), 'yyyy-MM-dd hh:mm:ss').substring(0, 10) + ' 00:00:00'
			params.endDate = date.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss').substring(0, 10) + ' 23:59:59'
		}
		return params;
	},
	//查询
	async queryWayBill(){
		this.$refs[this.ref].currentChange(1)
		this.queryBillCount()
	},
	async queryBillCount(){
		this.queryParams = this.buildQueryParams()
		let countList = await this.$api.getWayBillCountList(this.queryParams)
		this.billCountList = []
		let total = 0
		if(countList.length > 0){
			this.billCountList.push({tenantId: '', wayBillStatus: -1, wayBillStatusName: '全部', billCount: 0})
			for(let i = 0, len = countList.length; i < len; i++){
				total += countList[i].billCount;
				this.billCountList.push(countList[i]);
			}
			this.billCountList[0].billCount = total
			this.billCountLabel = this.getBillCountLabel(this.billCountList[0])
		}			
	},
	billCountItemChanged(){
		console.log(this.billCountLabel)
		for(let i = 0, len = this.billCountList.length; i < len; i++){
			if(this.billCountLabel == this.getBillCountLabel(this.billCountList[i])){
				this.wayBillStatus = this.billCountList[i].wayBillStatus
				// if(this.billCountList[i].spId){
				// 	this.spIdDepartName.push(this.billCountList[i].spId)
				// 	if(this.billCountList[i].spDepartName){
				// 		this.spIdDepartName.push(this.billCountList[i].spDepartName)
				// 	}else{
				// 		this.spIdDepartName.push('')						
				// 	}
				// }
				this.$refs[this.ref].currentChange(1)
				return;
			}
		}
	},	
	getBillCountLabel(item){
		switch(item.wayBillStatus){
		case 0:
			return '待走货' + item.billCount
		case 1:
			return '待提取' + item.billCount
		case 2:
			return '待签收' + item.billCount
		case 3:
			return '已签收' + item.billCount
		case 4:
			return '已退走' + item.billCount
		case 5:
			return '已作废' + item.billCount
		}
		return '全部' + item.billCount		
	},	
    // 重置表格
    getReset() {
      this.serviceStatus = 0
    },
    // 切换状态
    changstart(i) {
      this.serviceStatus = this.getnumtotitflog(this.serviceStatus, i)
    },
	getSpName(row){
		if(row.inDepartName){
			return row.inDepartName;
		}else{
			return this.crrbranch(row.tenantId).branchName
		}
	},	
    // 导出字段转义
    paraphrase(row, template) {
      if (template == 'spId') {
        return this.crrbranch(row.spId).branchName
      }
      if (template == 'operatingStatus') {
        return (this.operatingStatusList.find(item => row.operatingStatus == item.key) || {}).value
      }
      if (template == 'serviceStatus') {
        return this.numtotitflog(row.serviceStatus, 0) ? '港前问题' : this.numtotitflog(row.serviceStatus, 1) ? '港后问题' : this.numtotitflog(row.serviceStatus, 4) ? '收货问题' : this.numtotitflog(row.serviceStatus, 5) ? '欠费问题' : this.numtotitflog(row.serviceStatus, 3) ? '待退走' : ''
      }
      if (template == 'serviceInfo') {
        if (row.serviceInfo) {
          return row.serviceInfo + (row.serviceInfoTime ? row.serviceInfoTime.substring(5, 16) : '') + (row.serviceInfoToPerson ? row.serviceInfoToPerson : '')
        }
      }

      if (template == 'trackInfo') {
        if (row.publicTrackTime && row.trackTime) {
          if (row.publicTrackTime > row.trackTime) {
            return '【' + row.publicTrackTime + row.trackPlace + '】' + row.publicTrackInfo
          } else {
            return row.trackInfo
          }
        } else if (row.publicTrackTime) {
          return '【' + row.publicTrackTime + row.trackPlace + '】' + row.publicTrackInfo
        } else {
          return row.trackInfo
        }
      }
      if (template == 'battery') {
        return row.battery === '0' ? '无电' : row.battery === '1' ? '内电' : row.battery === '2' ? '外电' : '纯电'
      }
      if (template == 'gateDeclared') {
        return row.gateDeclared === '1' ? '报关' : '不报关'
      }
    }
  }
}
</script>

<style scoped>
</style>
